import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { List } from '../../partials/lists/list/List';
import { OnTopCard } from '../../partials/cards/onTopCard/OnTopCard';
import { useTheme } from '../../../theming/useTheme';
import { CardComponentDataProps } from '../../partials/cards/dividedCard/DividedCard';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { BaseUnit } from '../../../theming/baseUnitDefinition';

const createStyles = (baseUnit: BaseUnit) => StyleSheet.create({
  container: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gridGap: `${baseUnit / 2}px`,
    [MEDIA_BREAKPOINTS.LARGE]: {
      gridGap: `${baseUnit / 2}px`,
    },
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      gridTemplateColumns: '1fr 1fr',
      gridGap: `${baseUnit / 2}px`,
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto auto',
      gridGap: `${baseUnit / 2}px`,
    },
  },
});

interface HighlightsArticleListComponentDataProps {
  cardsProps: CardComponentDataProps[]
}

interface OnTopCardWithListSectionProps {
  baseUnit: BaseUnit
}

type HighlightsArticleListComponentProps = HighlightsArticleListComponentDataProps & OnTopCardWithListSectionProps;

export const HighlightsArticleListComponent: React.FunctionComponent<HighlightsArticleListComponentProps> = ({ cardsProps, baseUnit }) => {
  const styles = createStyles(baseUnit);
  const [onTopCardProps, ...listProps] = cardsProps;
  return (
    <div className={css(styles.container)}>
      <OnTopCard {...onTopCardProps} />
      <List listProps={listProps} />
    </div>
  );
};
const mapThemeToProps = (theme: OnTopCardWithListSectionProps) => ({
  baseUnit: theme.baseUnit,
});

export const HighlightsArticleList = (props: HighlightsArticleListComponentDataProps) => {
  const themeContext = useTheme(mapThemeToProps);
  return <ErrorBoundary><HighlightsArticleListComponent {...themeContext} {...props} /></ErrorBoundary>;
};
